import {useCallback} from "react";
import log from "loglevel";

type SnoozeEntity = "job" | "manifest";

type UseSnoozeIndicatorParams = {
  entityType: SnoozeEntity;
};

// DP-2999 scaffold: stubbed hook. Follow-up ticket will wire this to the
// `snoozeIndicator` GraphQL mutation added in nxtgen-services and optimistically
// clear the row's `indicatorColor` / push `indicatorSnoozeUntil` into the cache.
export const useSnoozeIndicator = ({entityType}: UseSnoozeIndicatorParams) => {
  const snooze = useCallback(
    (id: number, minutes: number) => {
      log.info("[DP-2999] useSnoozeIndicator stub invoked: %s id=%s minutes=%s", entityType, id, minutes);
    },
    [entityType]
  );

  return {snooze};
};
